var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-slider',{attrs:{"max":_vm.max,"min":_vm.min},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }